import { HEADER_BUTTON_IS_EMPTY_CLASS } from './constants';

/**
 * Update the count of the header icon.
 *
 * @param {number} numItems The number or items in the Wishlist.
 */
export function updateHeaderButtonCount( numItems ) {
	const buttons = document.querySelectorAll( '.qala-wishlist-header-count' );

	if ( ! buttons ) {
		return;
	}

	buttons.forEach( button => {
		button.innerHTML = numItems || '';

		if ( 0 === numItems ) {
			button.classList.add( HEADER_BUTTON_IS_EMPTY_CLASS );
			return;
		}
		button.classList.remove( HEADER_BUTTON_IS_EMPTY_CLASS );
	} );
}
